import { Countries } from "@enums/countries.enum";
import { ConvoyPermission, DoctorAssistantPermission, HIVAssistantPermission, HIVDoctorPermission, IraqiDoctorPermission, HIVPharmacistPermission } from "../_constants/permissions";
import { ClinicalPatientTypeEnum } from "@enums/clinical-patient-type.enum";

export function getPermissions(): string[] {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  return permissions;
}

export function getPermissionIfExists(requiredPermission: string): boolean {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  if (permissions) {
    return permissions.find(
      (p:any) => p.toLowerCase() == requiredPermission.toLowerCase()
    );
  }
  return false;
}

export function isPermissionExist(requiredPermission: string): boolean {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  if (permissions) {
    return permissions.some(
      (p:any) => p.toLowerCase() === requiredPermission.toLowerCase()
    );
  }
  return false;
}

export function isProgramExist(requiredProgram: string): boolean {
  const programs = JSON.parse(localStorage.getItem('programs') || '[]');
  if (programs) {
    return programs.find(
      (p:any) => p.toLowerCase() == requiredProgram.toLowerCase()
    );
  }
  return false;
}

export function isAssistantPermissionExist(requiredPermissions: string): boolean {
  const permissions = JSON.parse(localStorage.getItem('assistantPermissions') || '[]');
  if (permissions) {
    return permissions.find(
      (p:any) => p.toLowerCase() == requiredPermissions.toLowerCase()
    );
  }
  return false;
}

export function IsHIVDoctor(): boolean {
  var result = getPermissionIfExists(HIVDoctorPermission);
  return !!result;
}

export function IsIraqiDoctor(): boolean {
  var result = getPermissionIfExists(IraqiDoctorPermission);
  return !!result;
}

// for assistant
export function IsIraqiUser(): boolean {
  const countryId = +(localStorage.getItem('countryId') || 0);
  return countryId == Countries.Iraq;
}

export function IsHIVAssistant(): boolean {
  var result = getPermissionIfExists(HIVAssistantPermission);
  return !!result;
}

export function IsDoctorAssistant(): boolean {
  var result = getPermissionIfExists(DoctorAssistantPermission);
  return !!result;
}

export function IsHIVPharmacist(): boolean {
  var result = getPermissionIfExists(HIVPharmacistPermission);
  return !!result;
}

export function IsHIVUser(): boolean {
  return IsHIVDoctor() || IsHIVAssistant() || IsHIVPharmacist();
}

export function IsDoctorAssistantOnly(): boolean {
  const userPermissions = getPermissions();
  return userPermissions.length === 1 && userPermissions.some(p => p === DoctorAssistantPermission);
}

export function getClinicalPatientTypeByPermission(): ClinicalPatientTypeEnum {
  if (IsHIVUser()) {
    return ClinicalPatientTypeEnum.HIVPatient;
  }

  if (isPermissionExist(ConvoyPermission)) {
    return ClinicalPatientTypeEnum.ConvoyPatient;
  }

  // Default to regular patient
  return ClinicalPatientTypeEnum.Patient;
}
